import {
  type Employee,
  useStartTelegramLinkMutation,
  useUnlinkTelegramMutation,
} from '@/entities/employee'
import { errorMessage } from '@/shared/api'
import { Button } from '@/shared/ui/button'
import { Chip } from '@/shared/ui/chip'
import { toast } from '@/shared/ui/toast'

interface TelegramLinkProps {
  employee: Employee
}

/**
 * Привязка телеграма. Ссылку человек открывает сам — адрес чата берётся только
 * из мессенджера, иначе привязку оформили бы на чужой аккаунт. Секрет ссылки
 * одноразовый и живёт минуты.
 *
 * «Уведомления не доходят» показывается явно: человек закрыл бота, и без
 * отметки сообщения исчезали бы молча.
 */
export function TelegramLink({ employee }: TelegramLinkProps) {
  const start = useStartTelegramLinkMutation()
  const unlink = useUnlinkTelegramMutation()

  const openLink = () => {
    start.mutate(undefined, {
      onSuccess: (link) => {
        globalThis.open(link.url, '_blank', 'noopener')
        toast.info('Откройте ссылку в телеграме — она действует несколько минут')
      },
      onError: (error) => toast.error(errorMessage(error)),
    })
  }

  if (!employee.telegramLinked) {
    return (
      <Button size="sm" variant="secondary" onClick={openLink} disabled={start.isPending}>
        Привязать телеграм
      </Button>
    )
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {employee.telegramReachable ? (
        <Chip tone="success">телеграм привязан</Chip>
      ) : (
        <Chip tone="accent">уведомления не доходят</Chip>
      )}
      {!employee.telegramReachable && (
        <Button size="sm" variant="ghost" onClick={openLink} disabled={start.isPending}>
          Привязать заново
        </Button>
      )}
      <Button size="sm" variant="ghost" onClick={() => unlink.mutate()} disabled={unlink.isPending}>
        Отвязать
      </Button>
    </div>
  )
}
